import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import { CloseIcon } from '@ui/svgs/CloseIcon';
import Modal from '../Modal/Modal';
import theme from '../../../../ui/theme';
import CategoryFilterComponent from './CategoryFilterComponent';
import Button from '../Button/Button';

const HeaderBarDiv = styled.div`
  ${(p) => p.theme.typographyRebrand.body.lg}
  display: flex;

  justify-content: space-between;
`;

const DividerDiv = styled.div`
  height: 1px;
  margin: 0 -20px;
  background-color: ${(p) => p.theme.c.border.primary};
`;

const CloseButton = styled.button`
  ${(p) => p.theme.typographyRebrand.body.lg}
  border: none;
  cursor: pointer;
  color: ${(p) => p.theme.c.text.interactive};
  border: 0;
  background-color: transparent;
`;

const CloseButtonTextSpan = styled.span`
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
`;

const ClearFilterButton = styled.button`
  float: right;
  vertical-align: top;

  ${(p) => p.theme.typographyRebrand.body.md}
  border: none;
  background-color: transparent;
  color: ${(p) => p.theme.c.button.light.secondary.text.default};
  :hover {
    text-decoration: underline;
  }
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.unit(0.5)};

  padding: ${(p) => p.theme.unit(0.25)} ${(p) => p.theme.unit(1)};
  margin-bottom: ${(p) => p.theme.unit(1)};
`;

const CategoryFilterComponentWrapperDiv = styled.div`
  padding-bottom: ${(p) => p.theme.unit(7)};
`;

const SubcategoryTextDiv = styled.div`
  ${(p) => p.theme.typographyRebrand.heading['2xl']};
  color: ${(p) => p.theme.c.text.primary};
  margin-bottom: ${(p) => p.theme.unit(1.5)};
`;

const ApplyFilterSectionDiv = styled.div`
  margin-top: auto;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  padding-top: ${(p) => p.theme.unit(1)};
  padding-bottom: ${(p) => p.theme.unit(1)};
`;

const mobileStyles = {
  content: {
    top: '0',
    left: '0',
    right: 'auto',
    bottom: 'auto',
    border: 'none',
    borderRadius: '0',
    width: '100%',
    height: '100vh',
    overflow: 'scroll',
    boxSizing: 'border-box',
    scrollPaddingBottom: `${theme.unit(7)}`,
  },
  overlay: {
    backgroundColor: theme.c.overlay.background,
    zIndex: 100,
  },
};

const ModalContainerDiv = styled.div`
  z-index: ${(p) => p.theme.elevation[3]};
`;

const FilterModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
`;

class FilterModal extends Modal {
  constructor(props) {
    super(props);

    this.state = { ...this.state, categoryFiltersDictionary: {}, };

    this.toggleFilter = this.toggleFilter.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  updateModalBody(body, categoryFiltersDictionary, isMobile = true) {
    const newCategoryFilters = { ...categoryFiltersDictionary };
    this.setState({
      body,
      categoryFiltersDictionary: newCategoryFilters,
      isMobile,
    });
  }

  toggleFilter(filter) {
    this.state.categoryFiltersDictionary[filter] = !this.state.categoryFiltersDictionary[filter];
    this.setState({
      categoryFiltersDictionary: this.state.categoryFiltersDictionary,
    });
  }

  clearFilters() {
    Object.keys(this.state.categoryFiltersDictionary).forEach((filterKey) => {
      this.state.categoryFiltersDictionary[filterKey] = false;
    });
    this.setState({
      categoryFiltersDictionary: this.state.categoryFiltersDictionary,
    });
  }

  applyFilters() {
    const {
      applyFiltersCb,
      replaceFilterHash,
    } = this.props;

    replaceFilterHash(this.state.categoryFiltersDictionary);
    applyFiltersCb(this.state.categoryFiltersDictionary);
    this.closeModal();
  }

  render() {
    const {
      contentLabel = '', // TODO: accessibility for title of modal
      applyFilterButtonText,
      clearFiltersText,
      cancelFilterText,
      subcategoryFilterTitleText,
    } = this.props;

    const isOpen = !!this.state.body;

    const CloseButtonComp = () => {
      return (
        <CloseButton
          onClick={this.closeModal}>
          <CloseIcon title={cancelFilterText} />
          <CloseButtonTextSpan>
            {cancelFilterText}
          </CloseButtonTextSpan>
        </CloseButton>
      );
    };

    return (
      <ModalContainerDiv>

        {/* Mobile */}
        <ReactModal
          isOpen={isOpen}
          onRequestClose={this.closeModal}
          style={mobileStyles}
          contentLabel={contentLabel}
        >
          <FilterModalWrapper>
            <HeaderBarDiv>
              <CloseButtonComp />
              <ClearFilterButton
                onClick={this.clearFilters}>
                {clearFiltersText}
              </ClearFilterButton>
            </HeaderBarDiv>
            <DividerDiv />

            { this.state.body }

            <SubcategoryTextDiv>
              {subcategoryFilterTitleText}
            </SubcategoryTextDiv>
            <CategoryFilterComponentWrapperDiv>
              <CategoryFilterComponent
                categoryFiltersDictionary={this.state.categoryFiltersDictionary}
                toggleFilter={this.toggleFilter} />
            </CategoryFilterComponentWrapperDiv>

            <ApplyFilterSectionDiv>
              <DividerDiv />
              <ButtonWrapper>
                <Button
                  variant="primary"
                  size="small"
                  fullWidth
                  buttonText={applyFilterButtonText}
                  onClick={this.applyFilters}
                />
              </ButtonWrapper>
            </ApplyFilterSectionDiv>
          </FilterModalWrapper>
        </ReactModal>
      </ModalContainerDiv>
    );
  }
}

export default FilterModal;
